import { ReactComponent as add } from '../../assets/icons/add.svg'
import { ReactComponent as announcement } from '../../assets/icons/announcement.svg'
import { ReactComponent as appLauncher } from '../../assets/icons/appLauncher.svg'
import { ReactComponent as arrowDown } from '../../assets/icons/arrowDown.svg'
import { ReactComponent as arrowLeft } from '../../assets/icons/arrowLeft.svg'
import { ReactComponent as arrowRight } from '../../assets/icons/arrowRight.svg'
import { ReactComponent as arrowUp } from '../../assets/icons/arrowUp.svg'
import { ReactComponent as asterisk } from '../../assets/icons/asterisk.svg'
import { ReactComponent as attachment } from '../../assets/icons/attachment.svg'
import { ReactComponent as automation } from '../../assets/icons/automation.svg'
import { ReactComponent as bath } from '../../assets/icons/bath.svg'
import { ReactComponent as bed } from '../../assets/icons/bed.svg'
import { ReactComponent as calendar } from '../../assets/icons/calendar.svg'
import { ReactComponent as camera } from '../../assets/icons/camera.svg'
import { ReactComponent as car } from '../../assets/icons/car.svg'
import { ReactComponent as check } from '../../assets/icons/check.svg'
import { ReactComponent as checkOutline } from '../../assets/icons/checkOutline.svg'
import { ReactComponent as chevronDown } from '../../assets/icons/chevronDown.svg'
import { ReactComponent as chevronLeft } from '../../assets/icons/chevronLeft.svg'
import { ReactComponent as chevronRight } from '../../assets/icons/chevronRight.svg'
import { ReactComponent as chevronUp } from '../../assets/icons/chevronUp.svg'
import { ReactComponent as circularAdd } from '../../assets/icons/circularAdd.svg'
import { ReactComponent as circularAddSolid } from '../../assets/icons/circularAddSolid.svg'
import { ReactComponent as circularRemove } from '../../assets/icons/circularRemove.svg'
import { ReactComponent as circularRemoveSolid } from '../../assets/icons/circularRemoveSolid.svg'
import { ReactComponent as close } from '../../assets/icons/close.svg'
import { ReactComponent as cloud } from '../../assets/icons/cloud.svg'
import { ReactComponent as compliance } from '../../assets/icons/compliance.svg'
import { ReactComponent as contact } from '../../assets/icons/contact.svg'
import { ReactComponent as contacts } from '../../assets/icons/contacts.svg'
import { ReactComponent as copy } from '../../assets/icons/copy.svg'
import { ReactComponent as dashboard } from '../../assets/icons/dashboard.svg'
import { ReactComponent as dragIndicator } from '../../assets/icons/dragIndicator.svg'
import { ReactComponent as dragIndicatorAlt } from '../../assets/icons/dragIndicatorAlt.svg'
import { ReactComponent as edit } from '../../assets/icons/edit.svg'
import { ReactComponent as elipsis } from '../../assets/icons/elipsis.svg'
import { ReactComponent as email } from '../../assets/icons/email.svg'
import { ReactComponent as emailDisabled } from '../../assets/icons/emailDisabled.svg'
import { ReactComponent as emailFill } from '../../assets/icons/emailFill.svg'
import { ReactComponent as euro } from '../../assets/icons/euro.svg'
import { ReactComponent as exportIcon } from '../../assets/icons/exportIcon.svg'
import { ReactComponent as favourite } from '../../assets/icons/favourite.svg'
import { ReactComponent as feed } from '../../assets/icons/feed.svg'
import { ReactComponent as file } from '../../assets/icons/file.svg'
import { ReactComponent as fileDownload } from '../../assets/icons/fileDownload.svg'
import { ReactComponent as fileUpload } from '../../assets/icons/fileUpload.svg'
import { ReactComponent as filter } from '../../assets/icons/filter.svg'
import { ReactComponent as folder } from '../../assets/icons/folder.svg'
import { ReactComponent as forward } from '../../assets/icons/forward.svg'
import { ReactComponent as fullscreen } from '../../assets/icons/fullscreen.svg'
import { ReactComponent as fullscreenExit } from '../../assets/icons/fullscreenExit.svg'
import { ReactComponent as help } from '../../assets/icons/help.svg'
import { ReactComponent as info } from '../../assets/icons/info.svg'
import { ReactComponent as infoOutline } from '../../assets/icons/infoOutline.svg'
import { ReactComponent as insights } from '../../assets/icons/insights.svg'
import { ReactComponent as inspection } from '../../assets/icons/inspection.svg'
import { ReactComponent as insurance } from '../../assets/icons/insurance.svg'
import { ReactComponent as key } from '../../assets/icons/key.svg'
import { ReactComponent as keyboard } from '../../assets/icons/keyboard.svg'
import { ReactComponent as laptop } from '../../assets/icons/laptop.svg'
import { ReactComponent as link } from '../../assets/icons/link.svg'
import { ReactComponent as location } from '../../assets/icons/location.svg'
import { ReactComponent as locationAlt } from '../../assets/icons/locationAlt.svg'
import { ReactComponent as locationDisabled } from '../../assets/icons/locationDisabled.svg'
import { ReactComponent as lock } from '../../assets/icons/lock.svg'
import { ReactComponent as maintenance } from '../../assets/icons/maintenance.svg'
import { ReactComponent as maintenanceAlt } from '../../assets/icons/maintenanceAlt.svg'
import { ReactComponent as marketplace } from '../../assets/icons/marketplace.svg'
import { ReactComponent as menu } from '../../assets/icons/menu.svg'
import { ReactComponent as message } from '../../assets/icons/message.svg'
import { ReactComponent as messageDisabled } from '../../assets/icons/messageDisabled.svg'
import { ReactComponent as messageTyping } from '../../assets/icons/messageTyping.svg'
import { ReactComponent as micOff } from '../../assets/icons/micOff.svg'
import { ReactComponent as micOn } from '../../assets/icons/micOn.svg'
import { ReactComponent as minus } from '../../assets/icons/minus.svg'
import { ReactComponent as mobile } from '../../assets/icons/mobile.svg'
import { ReactComponent as money } from '../../assets/icons/money.svg'
import { ReactComponent as moodHappy } from '../../assets/icons/moodHappy.svg'
import { ReactComponent as moodNeutral } from '../../assets/icons/moodNeutral.svg'
import { ReactComponent as moodUnhappy } from '../../assets/icons/moodUnhappy.svg'
import { ReactComponent as more } from '../../assets/icons/more.svg'
import { ReactComponent as note } from '../../assets/icons/note.svg'
import { ReactComponent as notification } from '../../assets/icons/notification.svg'
import { ReactComponent as payment } from '../../assets/icons/payment.svg'
import { ReactComponent as phone } from '../../assets/icons/phone.svg'
import { ReactComponent as phoneDisabled } from '../../assets/icons/phoneDisabled.svg'
import { ReactComponent as photo } from '../../assets/icons/photo.svg'
import { ReactComponent as pin } from '../../assets/icons/pin.svg'
import { ReactComponent as pound } from '../../assets/icons/pound.svg'
import { ReactComponent as powerOn } from '../../assets/icons/powerOn.svg'
import { ReactComponent as property } from '../../assets/icons/property.svg'
import { ReactComponent as propertyChecked } from '../../assets/icons/propertyChecked.svg'
import { ReactComponent as radio } from '../../assets/icons/radio.svg'
import { ReactComponent as reapitLogo } from '../../assets/icons/reapitLogo.svg'
import { ReactComponent as reapitLogoSmall } from '../../assets/icons/reapitLogoSmall.svg'
import { ReactComponent as refresh } from '../../assets/icons/refresh.svg'
import { ReactComponent as repeat } from '../../assets/icons/repeat.svg'
import { ReactComponent as reply } from '../../assets/icons/reply.svg'
import { ReactComponent as replyAll } from '../../assets/icons/replyAll.svg'
import { ReactComponent as report } from '../../assets/icons/report.svg'
import { ReactComponent as sale } from '../../assets/icons/sale.svg'
import { ReactComponent as search } from '../../assets/icons/search.svg'
import { ReactComponent as settings } from '../../assets/icons/settings.svg'
import { ReactComponent as share } from '../../assets/icons/share.svg'
import { ReactComponent as sortAscend } from '../../assets/icons/sortAscend.svg'
import { ReactComponent as sortDescend } from '../../assets/icons/sortDescend.svg'
import { ReactComponent as star } from '../../assets/icons/star.svg'
import { ReactComponent as statusBad } from '../../assets/icons/statusBad.svg'
import { ReactComponent as statusGood } from '../../assets/icons/statusGood.svg'
import { ReactComponent as statusPaused } from '../../assets/icons/statusPaused.svg'
import { ReactComponent as statusUnknown } from '../../assets/icons/statusUnknown.svg'
import { ReactComponent as tag } from '../../assets/icons/tag.svg'
import { ReactComponent as task } from '../../assets/icons/task.svg'
import { ReactComponent as time } from '../../assets/icons/time.svg'
import { ReactComponent as trash } from '../../assets/icons/trash.svg'
import { ReactComponent as user } from '../../assets/icons/user.svg'
import { ReactComponent as video } from '../../assets/icons/video.svg'
import { ReactComponent as view } from '../../assets/icons/view.svg'
import { ReactComponent as viewDisabled } from '../../assets/icons/viewDisabled.svg'
import { ReactComponent as walking } from '../../assets/icons/walking.svg'
import { ReactComponent as warning } from '../../assets/icons/warning.svg'
import { ReactComponent as warningOutline } from '../../assets/icons/warningOutline.svg'
import { ReactComponent as workflow } from '../../assets/icons/workflow.svg'
import { ReactComponent as placeholderLarge } from '../../assets/placeholder-images/placeholderLarge.svg'
import { ReactComponent as placeholderSmall } from '../../assets/placeholder-images/placeholderSmall.svg'

export const iconSet = {
  add,
  announcement,
  appLauncher,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  asterisk,
  attachment,
  automation,
  bath,
  bed,
  calendar,
  camera,
  car,
  check,
  checkOutline,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  circularAdd,
  circularAddSolid,
  circularRemove,
  circularRemoveSolid,
  close,
  cloud,
  compliance,
  contact,
  contacts,
  copy,
  dashboard,
  dragIndicator,
  dragIndicatorAlt,
  edit,
  elipsis,
  email,
  emailDisabled,
  emailFill,
  euro,
  exportIcon,
  favourite,
  feed,
  file,
  fileDownload,
  fileUpload,
  filter,
  folder,
  forward,
  fullscreen,
  fullscreenExit,
  help,
  info,
  infoOutline,
  insights,
  inspection,
  insurance,
  key,
  keyboard,
  laptop,
  link,
  location,
  locationAlt,
  locationDisabled,
  lock,
  maintenance,
  maintenanceAlt,
  marketplace,
  menu,
  message,
  messageDisabled,
  messageTyping,
  micOff,
  micOn,
  minus,
  mobile,
  money,
  moodHappy,
  moodNeutral,
  moodUnhappy,
  more,
  note,
  notification,
  payment,
  phone,
  phoneDisabled,
  photo,
  pin,
  pound,
  powerOn,
  property,
  propertyChecked,
  radio,
  reapitLogo,
  reapitLogoSmall,
  refresh,
  repeat,
  reply,
  replyAll,
  report,
  sale,
  search,
  settings,
  share,
  sortAscend,
  sortDescend,
  star,
  statusBad,
  statusGood,
  statusPaused,
  statusUnknown,
  tag,
  task,
  time,
  trash,
  user,
  video,
  view,
  viewDisabled,
  walking,
  warning,
  warningOutline,
  workflow,
  // Placeholder Icons
  placeholderLarge,
  placeholderSmall,
}
